"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasuresAttributeIdentifier = "Measures";
exports.MetadataAttributeIdentifier = "Metadata";
//# sourceMappingURL=index.js.map